import { createContext, useContext } from "react"

const loadingContext = createContext(false)
export default loadingContext


export const useLoadingContext = () => {
    const { onClose, onOpen, isOpen, message, setMessage } = useContext(loadingContext)

    const onModalOpen = (msg) => {
        setMessage(msg)
        onOpen()
    }

    const onModalClose = () => {
        onClose()
    }

    return { onModalClose, onModalOpen, isOpen, message }
}